interface Title {
  as: string
  typo: string
  content: string
}

interface CTA {
  label: string
}

interface FaqItem {
  question: string
  answer: string
}

interface FaqGroup {
  title: string
  faqs: FaqItem[]
}

interface FaqProps {
  type: string
  sectionId: string
  colorScheme: string
  title: Title
  cta?: CTA
  faqs?: FaqItem[]
  groups?: FaqGroup[]
}

interface NormalizedFaq extends FaqProps {}

const Faq = ({
  type,
  sectionId,
  colorScheme,
  title,
  cta,
  faqs = [],
  groups = [],
}: FaqProps): NormalizedFaq => {
  const normalizedData: NormalizedFaq = {
    type,
    sectionId,
    colorScheme,
    title,
    cta,
    faqs,
    groups,
  }

  return normalizedData
}

export default Faq
